@if (finalAvatarUrl()) {
  <img
    class="avatar-img"
    [src]="finalAvatarUrl()"
    [alt]="altText()"
    referrerPolicy="no-referrer"
    [style.width.px]="size()"
    [style.height.px]="size()"
  />
} @else {
  <div
    class="avatar-placeholder"
    [style.width.px]="size()"
    [style.height.px]="size()"
    [style.fontSize.px]="size() * 0.45"
  >
    {{ letter() }}
  </div>
}

